import { mergeProps, splitProps } from "solid-js";
import classNames from "./classnames";
import { useBootstrapPrefix } from "./ThemeProvider";
import { Dynamic } from "solid-js/web";
const defaultProps = {};
const NavbarBrand = (p) => {
    const [local, props] = splitProps(mergeProps(defaultProps, p), ["as", "bsPrefix", "class"]);
    const bsPrefix = useBootstrapPrefix(local.bsPrefix, "navbar-brand");
    return (<Dynamic component={local.as || (props.href ? "a" : "span")} {...props} class={classNames(local.class, bsPrefix)}/>);
};
export default NavbarBrand;
